/* ============================================================
   Caché Perfume · Ecualizador de búsqueda
   ------------------------------------------------------------
   Filtra los resultados como quien mueve los diales de una radio.
   En colecciones (data-eq-servidor) cada dial pide a Shopify la
   colección ya filtrada, sin recargar (FUN-001, ver montarGrilla).
   En la búsqueda filtra EN VIVO las tarjetas de la página actual.

   Cada dial escribe un criterio; una tarjeta se muestra solo si
   pasa TODOS los diales activos. Los datos salen de los data-f-*
   que la sección escribió en cada .product.
   ============================================================ */
(function () {
  'use strict';

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toLocaleString(undefined, {
      minimumFractionDigits: n % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  /* ============================================================
     Grilla que se pide filtrada al servidor (colecciones)
     ------------------------------------------------------------
     CAG-007 (check "Show sold out"), FUN-001 (diales) y FUN-005 (Sort by) cambian
     la URL de la colección (filter.*, sort_by) y traen la misma sección ya
     filtrada con la Section Rendering API, SIN recargar: la grilla se atenúa
     mientras llega, las tarjetas entran en cascada y el alto se acomoda suave.
     La URL queda actualizada, así que el filtro sigue al paginar y con "Atrás".
     Expone raiz.__ir(url) para los diales.
     ============================================================ */
  function montarGrilla() {
    var raiz = document.querySelector('[data-shop][data-seccion]');
    if (!raiz || raiz.__ir || !window.fetch || !window.DOMParser) return;
    var grid = raiz.querySelector('[data-shop-grid]');
    if (!grid) return;

    var K = 'filter.v.availability';
    var seccion = raiz.dataset.seccion;
    var check = raiz.querySelector('[data-agotados]');
    var orden = raiz.querySelector('[data-shop-sort]');
    var quieto = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var curva = 'cubic-bezier(.2, .7, .3, 1)';
    var pedido = 0;

    function traer(u) {
      var pide = new URL(u);
      pide.searchParams.set('section_id', seccion);
      return fetch(pide.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r; return r.text(); })
        .then(function (html) {
          var otro = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shop]');
          if (!otro || otro.hasAttribute('data-llegada')) throw new Error('sin grilla');
          return otro;
        });
    }

    // Copia de "otro" lo que cambia con el filtro: tarjetas, contadores, vacío y paginación
    function poner(otro, desde) {
      var alto = grid.getBoundingClientRect().height;
      var nuevas = Array.prototype.map.call(otro.querySelectorAll('[data-shop-grid] > .product'), function (li) {
        return document.importNode(li, true);
      });
      grid.replaceChildren.apply(grid, nuevas);

      // El contador puede estar fuera de la grilla (en la búsqueda va arriba, junto al buscador)
      ['[data-shop-count]', '.shop__agot-n'].forEach(function (sel) {
        var a = document.querySelector(sel), b = otro.ownerDocument.querySelector(sel);
        if (a && b) a.textContent = b.textContent;
      });
      var vacio = raiz.querySelector('[data-eq-none]'), vacio2 = otro.querySelector('[data-eq-none]');
      if (vacio && vacio2) vacio.hidden = vacio2.hidden;
      var pg = raiz.querySelector('.shop__pager'), pg2 = otro.querySelector('.shop__pager');
      if (pg) pg.remove();
      if (pg2) raiz.appendChild(document.importNode(pg2, true));

      raiz.removeAttribute('data-llegada');
      grid.classList.remove('is-cargando');
      grid.dispatchEvent(new CustomEvent('cache:tarjetas'));
      if (quieto || !grid.animate) return;

      // Alto: del viejo al nuevo, en la misma curva
      var nuevoAlto = grid.getBoundingClientRect().height;
      if (Math.abs(nuevoAlto - alto) > 1) {
        grid.style.overflow = 'clip';
        grid.animate([{ height: alto + 'px' }, { height: nuevoAlto + 'px' }], { duration: 420, easing: curva })
          .onfinish = function () { grid.style.overflow = ''; };
      }
      // Cascada: solo las que se ven en pantalla, el resto aparece sin esperar
      var vh = window.innerHeight, n = 0;
      nuevas.forEach(function (li, i) {
        if (i < desde || li.hidden) return;
        var r = li.getBoundingClientRect();
        if (r.top > vh || r.bottom < 0) return;
        // Arranca del mismo tono atenuado de la grilla que se va: nunca queda en blanco
        li.animate([{ opacity: desde ? 0 : .45, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
          { duration: 320, delay: Math.min(n++, 8) * 22, easing: curva, fill: 'backwards' });
      });
    }

    // Va a la URL u: trae la página filtrada y la pone. Siempre vuelve a la página 1.
    function ir(u, desde) {
      u = new URL(u);
      u.searchParams.delete('page');
      // Con el check apagado se ven solo los disponibles (sin parámetro el servidor manda la "llegada")
      if (check && !u.searchParams.has(K)) u.searchParams.append(K, '1');
      var este = ++pedido;
      if (!desde) grid.classList.add('is-cargando');
      return traer(u).then(function (otro) {
        if (este !== pedido) return;
        history.replaceState(history.state, '', u.toString());
        poner(otro, desde || 0);
      }).catch(function () { if (este === pedido) location.href = u.toString(); });
    }
    raiz.__ir = ir;

    raiz.addEventListener('change', function (e) {
      var u = new URL(location.href);
      if (e.target === check) {
        u.searchParams.delete(K);
        (check.checked ? ['1', '0'] : ['1']).forEach(function (v) { u.searchParams.append(K, v); });
        ir(u);
      } else if (e.target === orden) {
        u.searchParams.set('sort_by', orden.value);
        ir(u);
      }
    });

    // Llegada sin filtro: ya se ven solo los disponibles de esta página; se trae la filtrada
    // y solo se suman tarjetas abajo
    if (raiz.hasAttribute('data-llegada')) {
      var ya = grid.querySelectorAll('.product:not([data-agotado])').length;
      ir(location.href, ya);
    }
  }

  function montarEq() {
    var eq = document.querySelector('[data-eq]');
    var shop = document.querySelector('[data-shop]');
    if (!shop) return;

    var grid  = shop.querySelector('[data-shop-grid]');
    var none  = shop.querySelector('[data-eq-none]');
    var count = shop.querySelector('[data-eq-count]');
    if (!grid) return;

    var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('.product'));
    var total = tarjetas.length;

    // Si no hay panel de diales, no hay nada que cablear
    if (!eq || eq.dataset.listo === '1') return;
    eq.dataset.listo = '1';

    // Estado de cada dial
    var estado = { gender: '', season: '', hours: '', conc: '', sale: '', price: Infinity };

    var resetBtn = eq.querySelector('[data-eq-reset]');
    var priceInput = eq.querySelector('[data-eq-price]');
    var priceOut = eq.querySelector('[data-eq-price-out]');
    var priceMax = priceInput ? Number(priceInput.max) : Infinity;

    // FUN-001: con data-eq-servidor (cache-eq-diales.liquid) los diales no esconden tarjetas:
    // arman la URL con los filtros de Search & Discovery de cada opción y montarGrilla trae la
    // colección ya filtrada. El estado de arranque lo pinta el servidor desde la URL.
    var servidor = eq.hasAttribute('data-eq-servidor') && shop.__ir;
    if (servidor) {
      eq.querySelectorAll('[data-eq-group]').forEach(function (dial) {
        var on = dial.querySelector('.eq__opt.is-on');
        if (on && dial.dataset.eqGroup in estado) estado[dial.dataset.eqGroup] = on.dataset.val || '';
      });
    }
    // Parámetros que manejan los diales (los demás de la URL, como sort_by o la disponibilidad, se respetan)
    var propios = ['page'];
    eq.querySelectorAll('[data-filtros]').forEach(function (b) {
      JSON.parse(b.dataset.filtros).forEach(function (par) { if (propios.indexOf(par[0]) < 0) propios.push(par[0]); });
    });
    if (priceInput && priceInput.dataset.param) propios.push(priceInput.dataset.param);

    var espera;
    function pedir() {
      if (!servidor) return;
      clearTimeout(espera);
      espera = setTimeout(function () {
        var u = new URL(location.href);
        propios.forEach(function (k) { u.searchParams.delete(k); });
        eq.querySelectorAll('.eq__opt.is-on[data-filtros]').forEach(function (b) {
          JSON.parse(b.dataset.filtros).forEach(function (par) { u.searchParams.append(par[0], par[1]); });
        });
        if (priceInput && priceInput.dataset.param && estado.price !== Infinity) {
          u.searchParams.set(priceInput.dataset.param, estado.price);
        }
        shop.__ir(u);
      }, 180);
    }

    function aplicar() {
      var visibles = 0;

      if (!servidor) tarjetas.forEach(function (t) {
        var ok = true;

        if (estado.gender && t.dataset.fGender !== estado.gender) ok = false;
        if (ok && estado.season && t.dataset.fSeason !== estado.season) ok = false;
        if (ok && estado.hours && t.dataset.fHours !== estado.hours) ok = false;
        if (ok && estado.conc && t.dataset.fConc !== estado.conc) ok = false;
        if (ok && estado.sale === '1' && t.dataset.fSale !== '1') ok = false;
        if (ok && estado.price !== Infinity) {
          var p = parseFloat(t.dataset.price || '0');
          if (p > estado.price) ok = false;
        }

        t.hidden = !ok;
        if (ok) visibles++;
      });

      // Contador y vacío de "esta página" (con los diales en el servidor los pone montarGrilla)
      if (servidor) {
        visibles = total;
      } else if (count) {
        if (visibles === total) {
          count.hidden = true;
        } else {
          count.hidden = false;
          count.textContent = visibles + ' of ' + total + ' shown';
        }
      }

      // Mensaje de vacío
      if (none && !servidor) none.hidden = visibles !== 0;

      // Botón reset visible solo si hay algo activo
      var activo = estado.gender || estado.season || estado.hours ||
                   estado.conc || estado.sale === '1' || estado.price !== Infinity;  /* FUN-008: era !== priceMax (300) y nunca se escondía */
      if (resetBtn) resetBtn.hidden = !activo;

      // Cuántos diales están activos, para el botón "Filters" de móvil
      if (marca) {
        var n = [estado.gender, estado.season, estado.hours, estado.conc,
                 estado.sale === '1', estado.price !== Infinity].filter(Boolean).length;
        marca.hidden = n === 0;
        marca.textContent = n;
      }
    }

    // --- Animaciones tipo app ---------------------------------------------------
    // Al abrir o cerrar un dial se mide cómo está todo, se aplica el cambio de
    // golpe (sin transición CSS), se mide cómo quedó y se anima entre las dos
    // medidas: cada opción crece o se encoge con su ancho real (no con un
    // max-width genérico, que hacía que el texto se fuera antes que la pastilla)
    // y los diales se deslizan cuadro a cuadro a su sitio nuevo, aunque cambien
    // de renglón. El panel (y la grilla de abajo) cambian de alto en la misma curva.
    var curva = 'cubic-bezier(.2, .7, .3, 1)';
    var suave = bezier(.2, .7, .3, 1);
    var dur = 380;
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var row = eq.querySelector('.eq__row');
    var altoAnim = null, enCurso = [], cuadro = 0;

    function bezier(x1, y1, x2, y2) {
      function b(a1, a2, t) { return 3 * a1 * t * (1 - t) * (1 - t) + 3 * a2 * t * t * (1 - t) + t * t * t; }
      return function (x) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        var lo = 0, hi = 1, t = x;
        for (var i = 0; i < 20; i++) { t = (lo + hi) / 2; if (b(x1, x2, t) < x) lo = t; else hi = t; }
        return b(y1, y2, t);
      };
    }
    function lista(sel) { return Array.prototype.slice.call(eq.querySelectorAll(sel)); }
    function medirOpt(o) {
      var cs = getComputedStyle(o);
      var pl = parseFloat(cs.paddingLeft), pr = parseFloat(cs.paddingRight);
      var w = o.getBoundingClientRect().width;
      return { w: cs.boxSizing === 'border-box' ? w : w - pl - pr, pl: pl, pr: pr, o: parseFloat(cs.opacity) };
    }

    function cortarAlto() {
      if (altoAnim) { altoAnim.onfinish = null; altoAnim.cancel(); altoAnim = null; }
      eq.classList.remove('is-animando');
    }
    function animarAlto(desde, hasta, alTerminar) {
      cortarAlto();
      if (quieto || !eq.animate || Math.abs(desde - hasta) < 1) { if (alTerminar) alTerminar(); return; }
      eq.classList.add('is-animando');
      altoAnim = eq.animate([{ height: desde + 'px' }, { height: hasta + 'px' }], { duration: dur, easing: curva });
      altoAnim.onfinish = function () { altoAnim = null; eq.classList.remove('is-animando'); if (alTerminar) alTerminar(); };
    }

    function flip(cambio) {
      if (quieto || !eq.animate) { cambio(); return; }
      var dials = lista('.eq__dial');
      var opts = lista('.eq__seg .eq__opt');
      var antes = dials.map(function (d) { return d.getBoundingClientRect(); });   // tal como se ve ahora
      var de = opts.map(medirOpt);
      var alto = eq.getBoundingClientRect().height;

      // Si había otra animación a medias, se corta: arrancamos desde lo que se ve
      cancelAnimationFrame(cuadro);
      enCurso.forEach(function (a) { a.cancel(); });
      enCurso = [];
      dials.forEach(function (d) { d.style.transform = ''; d.style.opacity = ''; });
      cortarAlto();

      eq.classList.add('eq--flip');
      cambio();
      var despues = dials.map(function (d) { return d.getBoundingClientRect(); });
      var a = opts.map(medirOpt);
      var altoFinal = eq.getBoundingClientRect().height;
      eq.classList.remove('eq--flip');

      opts.forEach(function (o, i) {
        var x = de[i], y = a[i];
        if (Math.abs(x.w - y.w) < .5 && Math.abs(x.o - y.o) < .01) return;
        enCurso.push(o.animate([
          { maxWidth: x.w + 'px', paddingLeft: x.pl + 'px', paddingRight: x.pr + 'px', opacity: x.o },
          { maxWidth: y.w + 'px', paddingLeft: y.pl + 'px', paddingRight: y.pr + 'px', opacity: y.o }
        ], { duration: dur, easing: curva }));
      });
      animarAlto(alto, altoFinal);

      // Los diales siguen la misma curva de su sitio viejo al nuevo: en cada cuadro
      // se mide dónde los deja el layout y se corrige con transform. El que cambia
      // de renglón no cruza en diagonal por encima de los otros: se apaga donde
      // estaba y se enciende en su sitio nuevo.
      var corte = .4;
      var salta = dials.map(function (d, i) { return Math.abs(despues[i].top - antes[i].top) > 2; });
      var ref = enCurso[0], t0 = performance.now();
      function paso() {
        var t = ref ? (ref.currentTime || 0) : performance.now() - t0;
        var p = Math.min(1, t / dur), k = suave(p);
        dials.forEach(function (d) { d.style.transform = ''; });
        var r = dials.map(function (d) { return d.getBoundingClientRect(); });
        dials.forEach(function (d, i) {
          if (p >= 1) { d.style.opacity = ''; return; }
          var x, y, escala = 1;
          if (salta[i]) {
            var antesDelCorte = p < corte;
            var q = antesDelCorte ? p / corte : (p - corte) / (1 - corte);
            x = antesDelCorte ? antes[i].left : despues[i].left;
            y = antesDelCorte ? antes[i].top : despues[i].top;
            d.style.opacity = antesDelCorte ? 1 - q : suave(q);
            if (!antesDelCorte) escala = .94 + .06 * suave(q);
          } else {
            x = antes[i].left + (despues[i].left - antes[i].left) * k;
            y = antes[i].top + (despues[i].top - antes[i].top) * k;
          }
          var dx = x - r[i].left, dy = y - r[i].top;
          if (Math.abs(dx) > .5 || Math.abs(dy) > .5 || escala < 1) {
            d.style.transform = 'translate(' + dx + 'px,' + dy + 'px)' + (escala < 1 ? ' scale(' + escala + ')' : '');
          }
        });
        if (p < 1) cuadro = requestAnimationFrame(paso);
      }
      paso();
    }

    // --- Plegado en móvil (COL-002): el panel se abre y cierra animado ---
    var toggle = eq.querySelector('[data-eq-toggle]');
    var marca = eq.querySelector('[data-eq-active]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var abrir = toggle.getAttribute('aria-expanded') !== 'true';
        var desde = eq.getBoundingClientRect().height;
        cortarAlto();
        if (row && row.getAnimations) row.getAnimations().forEach(function (a) { a.cancel(); });
        toggle.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        if (abrir) {
          eq.classList.add('is-open');
          animarAlto(desde, eq.getBoundingClientRect().height);
          if (!quieto && row && row.animate) {
            row.animate([{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'none' }], { duration: dur, easing: curva });
          }
        } else {
          eq.classList.remove('is-open');                  // medimos el alto cerrado…
          var hasta = eq.getBoundingClientRect().height;
          eq.classList.add('is-open');                     // …y lo dejamos abierto mientras se encoge
          if (!quieto && row && row.animate) {
            row.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-8px)' }], { duration: dur, easing: curva, fill: 'forwards' });
          }
          animarAlto(desde, hasta, function () {
            eq.classList.remove('is-open');
            if (row && row.getAnimations) row.getAnimations().forEach(function (a) { a.cancel(); });
          });
        }
      });
    }

    // --- Diales plegables: cerrados muestran solo la opción elegida; al tocarla
    //     se despliegan y al elegir se vuelven a cerrar (animado con flip) ---
    function cerrarDiales(salvo) {
      var abiertos = Array.prototype.slice.call(eq.querySelectorAll('.eq__dial.is-open'))
        .filter(function (d) { return d !== salvo; });
      if (!abiertos.length) return;
      flip(function () { abiertos.forEach(function (d) { d.classList.remove('is-open'); }); });
    }
    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element) || !e.target.closest('.eq__dial')) cerrarDiales();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarDiales(); });

    // --- Diales de segmentos (píldoras) ---
    eq.querySelectorAll('[data-eq-group]').forEach(function (dial) {
      var grupo = dial.dataset.eqGroup;
      if (grupo === 'price') return; // el precio se maneja aparte

      dial.querySelectorAll('.eq__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Cerrado: tocar la opción visible solo lo despliega (y pliega el que estuviera abierto)
          if (!dial.classList.contains('is-open')) {
            flip(function () {
              eq.querySelectorAll('.eq__dial.is-open').forEach(function (d) { d.classList.remove('is-open'); });
              dial.classList.add('is-open');
            });
            return;
          }
          flip(function () {
            dial.querySelectorAll('.eq__opt').forEach(function (b) { b.classList.remove('is-on'); });
            btn.classList.add('is-on');
            dial.classList.remove('is-open');
          });
          var antes = estado[grupo];
          estado[grupo] = btn.dataset.val || '';
          aplicar();
          if (estado[grupo] !== antes) pedir();
        });
      });
    });

    // --- Dial de precio (slider) ---
    if (priceInput) {
      var pintarPrecio = function () {
        var val = Number(priceInput.value);
        estado.price = (val >= priceMax) ? Infinity : val;
        if (priceOut) priceOut.textContent = (val >= priceMax) ? 'Any' : money(val);
        aplicar();
      };
      priceInput.addEventListener('input', pintarPrecio);
      priceInput.addEventListener('change', pedir);   // al soltar la barra, no en cada paso
      pintarPrecio();
    }

    // --- Reset ---
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        estado = { gender: '', season: '', hours: '', conc: '', sale: '', price: Infinity };
        eq.querySelectorAll('[data-eq-group]').forEach(function (dial) {
          if (dial.dataset.eqGroup === 'price') return;
          dial.querySelectorAll('.eq__opt').forEach(function (b, i) {
            b.classList.toggle('is-on', i === 0);
          });
        });
        if (priceInput) { priceInput.value = priceMax; if (priceOut) priceOut.textContent = 'Any'; }
        aplicar();
        pedir();
      });
    }

    aplicar();

    // CAG-007: llegaron tarjetas nuevas a la misma grilla (check "Show sold out"):
    // se vuelven a leer y se les aplican los diales que ya estaban puestos
    grid.addEventListener('cache:tarjetas', function () {
      tarjetas = Array.prototype.slice.call(grid.querySelectorAll('.product'));
      total = tarjetas.length;
      aplicar();
    });
  }

  function montar() { montarGrilla(); montarEq(); }   // la grilla primero: los diales usan su __ir

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
})();
